import { CSSObject } from '@emotion/core';
import { ComponentProps, ReactElement } from 'react';

import { Layout } from '@scripts/gds';
import { useMedia } from '@scripts/hooks';

type LayoutProps = Omit<ComponentProps<typeof Layout>, 'css'> & { css?: CSSObject };

type LayoutComponent = (props: LayoutProps) => ReactElement;

const LayoutWithMargin: LayoutComponent = ({ css, ...props }: LayoutProps): ReactElement => {
    const { md, xs } = useMedia();

    const defaultCss: CSSObject = {
        marginBottom: '64px',
        [md]: {
            marginBottom: '32px',
        },
        [xs]: {
            marginBottom: '24px',
        },
    };

    const mergedCss: CSSObject = css ? { ...defaultCss, ...css } : defaultCss;

    return <Layout {...(props as ComponentProps<typeof Layout>)} css={mergedCss} />;
};

export default LayoutWithMargin;
